itsoftApp.createModule("scrollEffects", ["windowScroll"], function() {
    var module = this;

    function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._obj = obj;
        this._callBack = callBack;
        this._scrollPoint;
        this._oldClass = oldClass;
        this.init();
    }

    ScrollEffects.prototype.init = function() {
        var self = this;

        function show (scroll, number) {
            var scrolled = pageYOffset;
            var coeff;

            if (number) {
                coeff = number;
            } else {
                coeff = 1.3;
            }

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);
            // console.log(scrolled + window.innerHeight / 2  + " " + (self._scrollPoint + scrolled));
            if (scrolled + window.innerHeight / coeff >= (self._scrollPoint + scrolled)) {
                self.fadeIn();
            }
        }

        show("auto", 1);

        itsoftApp.modules.windowScroll.addEvent(show);
    }

    ScrollEffects.prototype.fadeIn = function() {
        if (typeof this._callBack === "function") {
            this._callBack.call(this._obj);
        } else {
            if (this._oldClass) {
                this._self.classList.remove(this._oldClass);

                if (this._self.classList.contains("js-slider")) {
                    var sliderSettingsKey = this._self.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига
                    if (sliderSettingsKey && sliderSettingsObject) {
                        itsoftApp.modules.slidersLibrary.callback(this._self, sliderSettingsObject[sliderSettingsKey]);
                    } else {
                        itsoftApp.modules.slidersLibrary.callback(this._self);
                    }
                }

                if (this._self.classList.contains("js-accordion")) {
                    itsoftApp.modules.accordion.callback(this._self);
                }

                if (this._self.classList.contains("js-validation")) {
                    itsoftApp.modules.formsValidation.callback();
                }

                if (this._self.classList.contains("js-sharing")) {
                    itsoftApp.modules.sharing.callback();
                }

                this._oldClass = undefined;
            }
            this._self.classList.add(this._classAnimate);
        }
    }


    module.ScrollEffects = ScrollEffects;

});
